const LOCALE_TYPES = {
    en_US: 'en_US',
    en_IL: 'en_IL',
};

export default LOCALE_TYPES;